import { admissionOfficeWhoseDoc } from "@/src/constants/AdmissionOffice/admissionsOfficeConsts";
import { FORM_OF_EDUCATION_OPTIONS } from "@/src/constants/AdmissionOffice/Malta/maltaFormOfEducationOptions";

export interface SelectOption {
  value: string;
  label: string;
}

export const ADMISSION_OFFICE_ASSIGNEE_VALUE = "admission-office";
export const ADMISSION_OFFICE_ASSIGNEE_LABEL = "Admission Office";
export const DEFAULT_CHOOSE_ASSIGNEE = ADMISSION_OFFICE_ASSIGNEE_VALUE;
export const DEFAULT_MEDIUM_OF_INSTRUCTION = "english";
export const DEFAULT_ADMISSION_SEMESTER = "1st-semester";

export const chooseAssigneeOptions: SelectOption[] = [
  { value: ADMISSION_OFFICE_ASSIGNEE_VALUE, label: ADMISSION_OFFICE_ASSIGNEE_LABEL },
  ...admissionOfficeWhoseDoc.map((assignee) => ({
    value: assignee,
    label: assignee,
  })),
];

export const taskTypeOptions: SelectOption[] = [
  { value: "admission-letter", label: "Admission Letter" },
  { value: "admission-invoice-letter", label: "Admission/Invoice Letter" },
  { value: "student-letter", label: "Student Letter" },
  { value: "invoice-letter", label: "Invoice Letter" },
  { value: "payment-confirmation-letter", label: "Payment Confirmation Letter" },
  { value: "letter-of-acknowledgement", label: "Letter of Acknowledgement" },
  { value: "certificates", label: "Certificates" },
  { value: "doctors-certificate", label: "Doctor`s Certificate" },
  { value: "qr-code", label: "QR Code" },
];

export type TaskTypeValue = (typeof taskTypeOptions)[number]["value"];

/**
 * Task type → Admissions Office document slug (`admissionsOfficeHeaderTabsConst` / router).
 * Keys must stay in sync with `taskTypeOptions`.
 */
export const taskTypeToAdmissionDocumentSlug: Record<TaskTypeValue, string> = {
  "admission-letter": "admission",
  "admission-invoice-letter": "admission",
  "student-letter": "student",
  "invoice-letter": "invoice",
  "payment-confirmation-letter": "payment",
  "letter-of-acknowledgement": "acknowledgement",
  certificates: "certificates",
  "doctors-certificate": "certificates",
  "qr-code": "qr-code",
};

export const admissionSemesterOptions: SelectOption[] = [
  { value: "1st-semester", label: "1st Semester" },
  { value: "2nd-semester", label: "2nd Semester" },
  { value: "3rd-semester", label: "3rd Semester" },
  { value: "4th-semester", label: "4th Semester" },
  { value: "5th-semester", label: "5th Semester" },
  { value: "6th-semester", label: "6th Semester" },
  { value: "7th-semester", label: "7th Semester" },
  { value: "8th-semester", label: "8th Semester" },
  { value: "9th-semester", label: "9th Semester" },
  { value: "10th-semester", label: "10th Semester" },
  { value: "11th-semester", label: "11th Semester" },
  { value: "12th-semester", label: "12th Semester" },
  { value: "pg-phd-1st-semester", label: "PG/PhD 1st Semester" },
  { value: "pg-phd-2nd-semester", label: "PG/PhD 2nd Semester" },
  { value: "pg-phd-3rd-semester", label: "PG/PhD 3rd Semester" },
  { value: "pg-phd-4th-semester", label: "PG/PhD 4th Semester" },
  { value: "pg-phd-5th-semester", label: "PG/PhD 5th Semester" },
  { value: "pg-phd-6th-semester", label: "PG/PhD 6th Semester" },
];

export const formOfEducationOptions: SelectOption[] = FORM_OF_EDUCATION_OPTIONS.map(({ value, label }) => ({
  value,
  label,
}));

export const categoryOptions: SelectOption[] = [
  { value: "medicine", label: "Medicine" },
  { value: "dentistry", label: "Dentistry" },
  { value: "pharmacy", label: "Pharmacy" },
  { value: "nursing", label: "Nursing" },
  { value: "bachelors", label: "Bachelor`s" },
  { value: "masters", label: "Master`s" },
  { value: "pg-phd", label: "PG/PhD" },
];

export const mediumOfInstructionOptions: SelectOption[] = [
  { value: "english", label: "English" },
  { value: "ukrainian", label: "Ukrainian" },
];

export const durationOptions: SelectOption[] = [
  { value: "1-year", label: "1 Year" },
  { value: "2-years", label: "2 Years" },
  { value: "3-years", label: "3 Years" },
  { value: "4-years", label: "4 Years" },
  { value: "5-years", label: "5 Years" },
  { value: "6-years", label: "6 Years" },
];
